module.exports = __webpack_public_path__ + "static/img/rescueProcessing.6ff5e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personalInformation/rescueProcessing.png
// module id = v3TG
// module chunks = 55